"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TextareaComponent = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _autosize = _interopRequireDefault(require("autosize"));

var _Input = require("ipmp-react-ui/Input");

var _withNamedError = _interopRequireDefault(require("ipmp-react-ui/withNamedError"));

require("./textarea.sass");

var TextareaComponent =
/*#__PURE__*/
function (_InputComponent) {
  (0, _inherits2.default)(TextareaComponent, _InputComponent);

  function TextareaComponent() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, TextareaComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(TextareaComponent)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "element", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "ref", function (element) {
      _this.element = element;
      _this.props.autosize && element && (0, _autosize.default)(element);
    });
    return _this;
  }

  (0, _createClass2.default)(TextareaComponent, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.needUpdate && this.element && _autosize.default.update(this.element);
    }
  }, {
    key: "renderElement",
    value: function renderElement(props) {
      delete props.autosize;
      return _react.default.createElement("textarea", (0, _extends2.default)({}, props, {
        ref: this.ref,
        className: "input-field textarea-field",
        onChange: this.onChange,
        onFocus: this.onFocus,
        onBlur: this.onBlur
      }));
    }
  }, {
    key: "needUpdate",
    get: function get() {
      var _this$props = this.props,
          autosize = _this$props.autosize,
          value = _this$props.value;

      if (autosize) {
        return this.element.value !== value;
      }

      return false;
    }
  }]);
  return TextareaComponent;
}(_Input.InputComponent);

exports.TextareaComponent = TextareaComponent;
(0, _defineProperty2.default)(TextareaComponent, "propTypes", (0, _objectSpread2.default)({}, _Input.InputComponent.propTypes, {
  autosize: _propTypes.default.bool,
  value: _propTypes.default.string
}));
(0, _defineProperty2.default)(TextareaComponent, "defaultProps", {
  autosize: true
});

var _default = (0, _withNamedError.default)(TextareaComponent);

exports.default = _default;